(() => {
  const namespace = 'yhs-comc-final';
  const key = '__' + namespace.replaceAll('-', '_');
  if (window[key]) return;
  window[key] = true;
  document.addEventListener('click', (event) => {
    const pin = event.target.closest('[data-pin-target]');
    if (!pin || !pin.closest('[data-yhs-final-root="yhs-comc-final"]')) return;
    const root = pin.closest('[data-yhs-final-root="yhs-comc-final"]');
    const target = root.querySelector('#' + CSS.escape(pin.dataset.pinTarget));
    if (!target) return;
    target.open = true;
    target.querySelector('summary')?.focus({ preventScroll: true });
  });
})();

(() => {
  const namespace = 'yhs-comc-final';
  const selector = `[data-yhs-final-root="${namespace}"]`;
  const key = '__' + namespace.replaceAll('-', '_') + '_consultation';
  if (window[key] || !document.querySelector(selector)) return;
  window[key] = true;
  const panel = document.createElement('div');
  panel.className = 'consultation';
  panel.dataset.open = 'false';
  panel.innerHTML = `<div class="consult-dialog" hidden><div class="consult-backdrop"></div><div class="consult-toolbar"><span>YHS consultation</span><button type="button" data-consult-close>Close chat</button></div><p class="consult-fallback" hidden>Chat is loading. <a href="/pages/contact-request-a-quote">Send your project inquiry</a></p></div>`;
  const dialog = panel.querySelector('.consult-dialog');
  const fallback = panel.querySelector('.consult-fallback');
  let primary = null;
  let trigger = null;
  let seenOpen = false;
  const watched = new WeakSet();
  const launcher = element => element?.id === 'tidio-chat'
    ? element.shadowRoot?.querySelector('#button-body')
    : element?.shadowRoot?.querySelector('shopify-agent-runtime')?.shadowRoot?.querySelector('[part~="activator"]') || element?.shadowRoot?.querySelector('[part~="activator"]');
  const isOpen = element => element?.id === 'tidio-chat'
    ? element.shadowRoot?.querySelector('#button')?.classList.contains('chat-open')
    : launcher(element)?.getAttribute('aria-expanded') === 'true';
  const close = () => {
    if (panel.dataset.open !== 'true') return;
    panel.dataset.open = 'false';
    if (isOpen(primary)) launcher(primary)?.click();
    dialog.hidden = true;
    trigger?.setAttribute('aria-expanded', 'false');
    trigger?.focus({ preventScroll: true });
    primary = null;
    seenOpen = false;
  };
  const sync = () => {
    if (panel.dataset.open !== 'true' || !primary) return;
    if (isOpen(primary)) seenOpen = true;
    else if (seenOpen && launcher(primary)) close();
  };
  const open = button => {
    trigger = button;
    primary = [document.querySelector('#tidio-chat'), document.querySelector('shopify-chat')].find(e => launcher(e));
    seenOpen = false;
    panel.dataset.open = 'true';
    panel.dataset.provider = primary?.id === 'tidio-chat' ? 'tidio' : 'shopify';
    dialog.hidden = false;
    fallback.hidden = Boolean(primary);
    trigger.setAttribute('aria-expanded', 'true');
    if (primary) {
      if (!isOpen(primary)) launcher(primary).click();
      sync();
      for (const shadow of [primary.shadowRoot, primary.shadowRoot?.querySelector('shopify-agent-runtime')?.shadowRoot].filter(Boolean)) {
        if (watched.has(shadow)) continue;
        watched.add(shadow);
        new MutationObserver(sync).observe(shadow, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'aria-expanded', 'open'] });
      }
    }
  };
  const mount = () => {
    const roots = [...document.querySelectorAll(selector)];
    if (!roots.length) { close(); panel.remove(); return; }
    if (!panel.isConnected) roots[0].querySelector('.inner').append(panel);
    for (const actions of roots.flatMap(r => [...r.querySelectorAll('.actions')])) {
      if (actions.querySelector('[data-consult-open]')) continue;
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'consult-trigger';
      button.dataset.consultOpen = '';
      button.textContent = roots[0].dataset.consultLabel || 'Chat with YHS';
      button.setAttribute('aria-expanded', 'false');
      actions.append(button);
    }
    const closeButton = panel.querySelector('[data-consult-close]');
    const closeLabel = roots[0].dataset.consultClose || 'Close chat';
    if (closeButton.textContent !== closeLabel) closeButton.textContent = closeLabel;
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-consult-open]');
    if (button?.closest(selector)) open(button);
  });
  panel.querySelector('[data-consult-close]').addEventListener('click', close);
  panel.querySelector('.consult-backdrop').addEventListener('click', close);
  document.addEventListener('keydown', event => { if (event.key === 'Escape' && panel.dataset.open === 'true') close(); });
  mount();
  new MutationObserver(mount).observe(document.body, { subtree: true, childList: true });
})();
